import { render } from "./realNameCourse.vue?vue&type=template&id=6171362e&scoped=true"
import script from "./realNameCourse.vue?vue&type=script&lang=js"
export * from "./realNameCourse.vue?vue&type=script&lang=js"

import "./realNameCourse.vue?vue&type=style&index=0&id=6171362e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_FAnl/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6171362e"]])

export default __exports__